import axiosInstance from "../api/axios";

export const updateUserProfile = async (payload) => {
  const res = await axiosInstance.post("/api/user/update-profile", payload);
  return res.data;
};
export const getUserProfile = async () => {
  const res = await axiosInstance.get("/api/user/view-profile");
  return res.data;
};
